// Unpublished Work © 2021-2022 Deere & Company

import t from 'tcomb';
import {Communication} from '../../customer/communication';
import {CustomerName} from '../../customer/customer-name';
import {CustomerType, customerTypes} from '../../../enum/customer-type';

export const CustomerDetails = t.struct({
    communication: Communication,
    customerName: CustomerName,
    customerType: CustomerType
}, {
    defaultProps: {
        communication: Communication({}),
        customerName: CustomerName({}),
        customerType: customerTypes.INDIVIDUAL
    },
    name: 'CustomerDetails',
    strict: true
});

CustomerDetails.prototype.hasPrefilledCustomerDetails = function () {
    const defaultState = CustomerDetails({});

    const allEqual = [
        defaultState.communication === this.communication,
        defaultState.customerName === this.customerName,
        defaultState.customerType === this.customerType
    ].every((pass) => pass);

    return !allEqual;
};
